import React, { useEffect, useState } from 'react';
import TransportAccess from './TransportAccess'; 
import FutureGraph_ProjectDetail from './futureGraph_ProjectDetail';
import JobImpact_detail from './jobImpact_detail';
import NearestInfrastructure_detail from '../NestComponent_Project/NearestInfrastructure/nearestInfrastructure_detail';
import Populationgraph from './populationgraph';
import SocialImpactCards from './socialImpact';
import { GetTransportDetail } from '../../../FeatureRedux/ProjectionReducer/TransportProjectionReducer/getTransport_Projection_reducre';
import { useDispatch, useSelector } from 'react-redux';

function ProjectProjection({ projectiondata , showtwo }) {
  const [show, setShow] = useState({});
  const [locations, setLocations] = useState([]);

  useEffect(() => {
    if (projectiondata ) {
      setShow(projectiondata);
      // console.log("  projectiondata provided:", projectiondata);
    } else {
      console.warn("Invalid projectiondata provided:", projectiondata);
      setShow({}); 
    }
  }, [projectiondata]);
   
  const { data, isError, isSuccess } = useSelector((s) => s.GetTransportDetail); 
  const dispatch = useDispatch()
    useEffect(() => {
      if (projectiondata && !data ) {
        dispatch(GetTransportDetail(projectiondata));
      }
    }, [dispatch, projectiondata]);


    


    useEffect(() => {
      if (isSuccess && data) {
        setLocations(data?.graphData || []);
        // setCurrentPage(1); // Reset to first page when data changes
        // console.log("thisisi slcoation sidhiahiiejhf" , locations)
      }
    }, [isSuccess, data]);

  return (
    <div className={`grid ${showtwo ? 'grid-cols-1' : 'grid-cols-1 md:grid-cols-2 lg:grid-cols-3'} gap-4 p-4`}>


      {/* Transportation Access */}
      {(() => {
        try {
          return show?.transportation_access ? (
            <div className="p-4 border border-gray-700 rounded-lg shadow bg-gray-800 text-white text-center">
              {/* <h2 className="text-lg font-semibold mb-2 text-center">Transportation Access</h2> */}
              <TransportAccess projectiondataID={projectiondata.projectid} />
            </div>
          ) : null;
        } catch (err) {
          console.error("Error rendering Transportation Access:", err);
          return null;
        }
      })()}
      

      {/* Nearest Infrastructure */}
      {(() => {
        try {
          return show?.nearest_infra ? (
            <div className="p-4 border border-gray-700 rounded-lg shadow bg-gray-800 text-white text-center">
              {/* <h2 className="text-lg font-semibold mb-2">Nearest Infrastructure</h2> */}
              <NearestInfrastructure_detail projectiondataID={projectiondata.projectid} />
            </div>
          ) : null;
        } catch (err) {
          console.error("Error rendering Nearest Infrastructure:", err);
          return null;
        }
      })()}

      {/* Social Impact */}
      {(() => {
        try {
          return show?.social_impact ? (
            <div className="p-4 border border-gray-700 rounded-lg shadow bg-gray-800 text-white text-center">
              {/* <h2 className="text-lg font-semibold mb-2">Banking Partners</h2> */}
              <SocialImpactCards />
            </div>
          ) : null;
        } catch (err) {
          console.error("Error rendering Social Impact:", err);
          return null;
        }
      })()}

      {/* Job Impact */} 
      {(() => {
        try {
          return show?.job_impact ? (
            <div className="p-4 border border-gray-700 rounded-lg shadow bg-gray-800 text-white text-center">
              {/* <h2 className="text-lg font-semibold mb-2">Job Impact</h2> */}
              <JobImpact_detail projectiondataID={projectiondata} locations={locations} />
            </div>
          ) : null;
        } catch (err) {
          console.error("Error rendering Job Impact:", err);
          return null;
        }
      })()}

      {/* Population Trends */}
      {(() => {
        try {
          return show?.population_projection ? (
            <div className="p-4 border border-gray-700 rounded-lg shadow bg-gray-800 text-white text-center">
              {/* <h2 className="text-lg font-semibold mb-2">Population Trends</h2> */}
              <Populationgraph projectiondataID={projectiondata} locations={locations}/>
            </div>
          ) : null;
        } catch (err) {
          console.error("Error rendering Population Trends:", err);
          return null;
        }
      })()}

      {/* Land Price Prediction */}
      {(() => {
        try {
          return show?.land_price ? (
            <div className="p-4 border border-gray-700 rounded-lg shadow bg-gray-800 text-white text-center">
              {/* <h2 className="text-lg font-semibold mb-2">Land Price Prediction</h2> */}
              <FutureGraph_ProjectDetail projectiondataID={projectiondata} locations={locations}/>
            </div>
          ) : null;
        } catch (err) {
          console.error("Error rendering Land Price Prediction:", err);
          return null;
        }
      })()}
    </div>
  );
}

export default ProjectProjection;


// import React from 'react';
// import NearestLocation from './nearestLocation';
// import BankingPartner_detailProject from './bankingPartner_detailProject';
// import FutureGraph_ProjectDetail from './futureGraph_ProjectDetail';
// import JobImpact_detail from './jobImpact_detail';
// import NearestInfrastructure_detail from './nearestInfrastructure_detail';
// import Populationgraph from './populationgraph';

// function ProjectProjection() {
//   return (
//     <div className="flex flex-wrap md:flex-nowrap gap-4 p-4">
//       {/* Project Location */}
//       <div className="flex-1 p-4 border border-gray-700 rounded-lg shadow bg-gray-800 text-white text-center">
//         <h2 className="text-lg font-semibold">Transportation Access</h2>
//         <NearestLocation/>
//       </div>

//       {/* Future Prediction */}
//       <div className="flex-1 p-4 border border-gray-700 rounded-lg shadow bg-gray-800 text-white text-center">
//         <h2 className="text-lg font-semibold">Impact On Land Prices Prediction</h2>
//         <FutureGraph_ProjectDetail/>
        
//       </div>

//       {/* Past History */}
//       <div className="flex-1 p-4 border border-gray-700 rounded-lg shadow bg-gray-800 text-white text-center">
//         <h2 className="text-lg font-semibold">Job Impact</h2>
//         <JobImpact_detail/>
//       </div>

//       {/* Banking Partner */}
//       <div className="flex-1 p-4 border border-gray-700 rounded-lg shadow bg-gray-800 text-white text-center">
//         <h2 className="text-lg font-semibold">Banking Partner</h2>
//         <BankingPartner_detailProject/>
//       </div>
//       <div className="flex-1 p-4 border border-gray-700 rounded-lg shadow bg-gray-800 text-white text-center">
//         <h2 className="text-lg font-semibold">Nearest Infrastructure</h2>
//         <NearestInfrastructure_detail/>
//       </div>
//       <div className="flex-1 p-4 border border-gray-700 rounded-lg shadow bg-gray-800 text-white text-center">
//         <h2 className="text-lg font-semibold">Nearest Infrastructure</h2>
//         <Populationgraph/>
//       </div>
//     </div>
//   );
// }

// export default ProjectProjection;
